import PropTypes from 'prop-types';
import React from 'react';

import { CarouselRelated, GridInsight } from '$partials/modules/blocks';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const FeaturedInsights = ({
    items     = null,
    sideTitle = null,
}) => {
    const count = items?.length;

    switch (count) {
    case 0:
        return null;
        break;

    case 1:
    case 2:
    case 3:
        return (
            <GridInsight
                largeItems={items}
                sideTitle={sideTitle}
                smallItems={items} />
        );
        break;

    default:
        return (
            <CarouselRelated
                items={items}
                sideTitle={sideTitle} />
        );
        break;
    }
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    items    : PropTypes.array,
    sideTitle: PropTypes.string,
};

FeaturedInsights.propTypes = propTypes;

export { FeaturedInsights };

export default FeaturedInsights;
